var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActiveStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm5.438 2.837l1.12 2.14 2.366.306a.5.5 0 01.271.867L9.464 7.715l.426 2.273a.5.5 0 01-.723.535L7 9.392l-2.273 1.146a.5.5 0 01-.716-.543l.453-2.28-1.686-1.569a.5.5 0 01.276-.862l2.352-.307 1.148-2.144a.5.5 0 01.884.004z",
    fill: "#F06885"
  })));
}

export default SvgActiveStar;